import { AfterViewInit, Component, HostListener, Input, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcpButtonModule, FcpModalModule, FcpModalService, ModalSizes } from 'fc-ui-components';
import { AutoUnsubscribe } from 'helpers';
import { OrderSheetItem } from 'app/b2b-order/services/order-sheet/types';
import { ProductSwitchService } from 'app/b2b-order/services/product-switch/product-switch.service';
import { DisplayMode } from 'app/components/accordion/shopping-cart-accordion.component';
import { MediaBreakpoint } from 'app/components/responsive-wrapper/constants';
import { ShoppingCartItem, ShoppingCartService } from 'app/b2b-order/services/shopping-cart';
import { OrderSheetService } from 'app/b2b-order/services/order-sheet';

@Component({
    selector: 'fc-product-switch-modal',
    templateUrl: './product-switch-modal.component.html',
    styleUrls: ['./product-switch-modal.component.less'],
    imports: [FcpButtonModule, FcpModalModule, TranslateModule],
    encapsulation: ViewEncapsulation.None,
    standalone: true
})
@AutoUnsubscribe
export class ProductSwitchModalComponent implements AfterViewInit {
    constructor(
        private fcpModalService: FcpModalService,
        private shoppingCartService: ShoppingCartService,
        private orderSheetService: OrderSheetService,
        private productSwitchService: ProductSwitchService
    ) {}

    protected readonly ModalSizes = ModalSizes;
    @Input() titleText: string;
    @Input() captionText: string;
    @Input() cancelText: string;
    @Input() confirmText: string;
    @Input() switchTo: SwitchToProductType;
    displayMode: DisplayMode = DisplayMode.Desktop;

    cancel() {
        this.fcpModalService.close(productSwitchModalId);
    }

    confirm() {
        if (this.switchTo === SwitchToProductType.Reorder) {
            this.fcpModalService.close(productSwitchModalId);
            this.orderSheetService.clear(false);
            this.shoppingCartService.add(
                this.productSwitchService.articlesToAddAfterProductSwitch as ShoppingCartItem[]
            );
            this.productSwitchService.articlesToAddAfterProductSwitch = [];
        } else if (this.switchTo === SwitchToProductType.Preorder) {
            this.fcpModalService.close(productSwitchModalId);
            this.shoppingCartService.clear(false);
            this.orderSheetService.add(this.productSwitchService.articlesToAddAfterProductSwitch as OrderSheetItem[]);
            this.productSwitchService.articlesToAddAfterProductSwitch = [];
        }
    }

    public get DisplayMode() {
        return DisplayMode;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.setDisplayMode(event.target.innerWidth);
    }

    ngAfterViewInit() {
        this.setDisplayMode(window.innerWidth);
    }

    private setDisplayMode(width: number) {
        if (width < MediaBreakpoint.Desktop) this.displayMode = DisplayMode.Mobile;
        else this.displayMode = DisplayMode.Desktop;
    }

    protected readonly productSwitchModalId = productSwitchModalId;
}

export const productSwitchModalId = 'product-switch-modal';

export enum SwitchToProductType {
    Reorder,
    Preorder
}
